<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <kbd :class="cn('inline-flex items-center gap-1', props.class)">
    <slot />
  </kbd>
</template>
